export default {"src":"/_next/static/media/star.cce816a2.svg","height":22,"width":22};